import React from "react"
import {useTranslation} from "react-i18next"
import {CheckIcon} from "@heroicons/react/20/solid"

import Button from "../../../../components/Button"
import {ConfirmModal} from "../../../../components/Modal"
import {useSkipNotificationApproveProspectsMutation} from "../../../../queries/prospects"
import requestError from "../../../../services/requestError"

export const SkipNotificationApproveButton: React.FC<{assignmentId: number}> = ({assignmentId}) => {
  const {t} = useTranslation()

  const [isVisible, setIsVisible] = React.useState(false)

  const approveMutation = useSkipNotificationApproveProspectsMutation()

  const handleConfirm = React.useCallback(async () => {
    try {
      await approveMutation.mutateAsync(assignmentId)
    } catch (e) {
      requestError(e)
    }
  }, [assignmentId, approveMutation])

  return (
    <>
      <Button onClick={() => setIsVisible(true)} variant={"outlined"} color={"gray"} iconLeft={<CheckIcon />}>
        {t("Prospects_ApproveProspects_Button")}
      </Button>

      <ConfirmModal
        onConfirm={handleConfirm}
        title={t("Prospects_ApproveProspects_SkipNotification_Title")}
        isOpen={isVisible}
        onClose={() => setIsVisible(false)}
        confirmButtonText={t("Prospects_ApproveProspects_SkipNotification_ConfirmButton")}
        variant={"warning"}
      >
        <div className={"font-bold"}>{t("Prospects_ApproveProspects_SkipNotification_TextHeader")}</div>
        {t("Prospects_ApproveProspects_SkipNotification_Text")}
      </ConfirmModal>
    </>
  )
}
